import React from "react";
import { Link } from "react-router";
import { RUBRIC_COLOR } from "../tokens";
import { useDataDependency } from "../utils/RemoteDataProvider";
import { useSettings } from "../utils/settings";
import { useCalcheck } from "./calcheck-utils";

export const CalWarning: React.FC<{}> = () => {
    const loadableTextList = useDataDependency<string[]>({
        type: "ord text list",
    });

    const { getNextDayWithIssues } = useCalcheck(loadableTextList);

    const nextDayWithIsssues = getNextDayWithIssues();

    const { settings } = useSettings();

    if (settings.oneDayAheadPsalter !== "true") {
        return <></>;
    }

    if (loadableTextList.state === "loaded" && nextDayWithIsssues) {
        return (
            <div style={{ paddingBottom: 24 }}>
                <div style={{ padding: 8, border: "1px solid silver" }}>
                    <div style={{ fontWeight: "bold" }}>
                        Next issue in{" "}
                        <span style={{ textDecoration: "underline" }}>
                            {nextDayWithIsssues.daysInFuture} days
                        </span>
                    </div>
                    <div>AM</div>
                    {nextDayWithIsssues.amIssues.map((issue) => {
                        return (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    gap: 8,
                                    opacity: issue.outranked ? 0.5 : 1,
                                }}
                            >
                                <div style={{ fontWeight: "bold" }}>
                                    {issue.celebration.title}
                                </div>
                                <Link
                                    to={`se/${issue.day.year}/${issue.day.month}/${issue.day.date}/${issue.celebration.label}/${issue.hour}`}
                                    style={{
                                        color: RUBRIC_COLOR,
                                    }}
                                >
                                    Open
                                </Link>
                                {issue.issues.map((i) => (
                                    <div>{i}</div>
                                ))}
                            </div>
                        );
                    })}
                    <div>PM</div>
                    {nextDayWithIsssues.pmIssues.map((issue) => {
                        return (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                    gap: 8,
                                    opacity: issue.outranked ? 0.5 : 1,
                                }}
                            >
                                <div style={{ fontWeight: "bold" }}>
                                    {issue.celebration.title}
                                </div>
                                <Link
                                    to={`se/${issue.day.year}/${issue.day.month}/${issue.day.date}/${issue.celebration.label}/${issue.hour}`}
                                    style={{
                                        color: RUBRIC_COLOR,
                                    }}
                                >
                                    Open
                                </Link>
                                {issue.issues.map((i) => (
                                    <div>{i}</div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    } else {
        return <div>Checking for issues...</div>;
    }
};
